import AccountData from '../../domain/AccountData';

const sampleData: AccountData = {
    billingAddress: {
        name: '',
        address: '',
        postCode: '',
        city: '',
        country: '',
        countryCode: '',
        state: '',
        contact: {
            name: '',
            phone: '',
            email: ''
        }
    },
    shippingAddress: {
        name: '',
        address: '',
        postCode: '',
        city: '',
        country: '',
        countryCode: '',
        state: '',
        contact: {
            name: '',
            phone: '',
            email: ''
        },
        phone: '',
        email: ''
    }
};

export default sampleData;



// WEBPACK FOOTER //
// ./src/application/account/sampleData.ts